import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useSidebarState } from "../hooks/useSidebarState";
import { cn } from "../lib/cn";

type AppShellProps = React.PropsWithChildren<{
  contentClassName?: string;
  mainClassName?: string;
}>;

const AppShell = ({ children, contentClassName, mainClassName }: AppShellProps) => {
  const { isSidebarExpanded, toggleSidebar } = useSidebarState();

  return (
    <div className="bg-gradient-to-b from-orange-200 to-orange-50 font-montserrat dark:from-orange-800 dark:to-gray-950">
      <Header />
      <Sidebar onToggle={toggleSidebar} isExpanded={isSidebarExpanded} />
      <div
        className={cn(
          "flex h-screen pt-16 transition-all duration-100",
          isSidebarExpanded ? "sm:ml-64" : "sm:ml-16",
          mainClassName
        )}
      >
        <div className="w-full max-w-full overflow-hidden">
          <main className={cn("h-full overflow-auto", contentClassName)}>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default AppShell;
